import { Flex, type FlexProps } from '@chakra-ui/react';
import { useCarouselContext } from './carouselContext';

type Props = FlexProps;

/** One item of a Carousel, sized to share the row with the others in view. */
export const CarouselItem = ({ children, ...props }: Props) => {
  const { itemBasis } = useCarouselContext();

  return (
    <Flex
      flex={`0 0 ${itemBasis}`}
      minW={0}
      sx={{ scrollSnapAlign: 'start' }}
      {...props}
    >
      {children}
    </Flex>
  );
};
